import { render, staticRenderFns } from "./clayStylize.vue?vue&type=template&id=b383ee3c&scoped=true&"
import script from "./clayStylize.vue?vue&type=script&lang=js&"
export * from "./clayStylize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b383ee3c",
  null
  
)

export default component.exports